import useTranslate from 'hooks/useTranslate';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';
import { useNavigate } from 'react-router-dom';
import { useGetTemplateDetailsQuery } from 'services';
import './styles.scss';
import { S3_URL } from 'constants';
import { TemplatePreviewSkeleton } from 'components/Common/Skeleton/Resume';

interface TemplatePreviewProps {
	show: boolean;
	handleClose: () => void;
	data: any;
}

const TemplatePreview: React.FC<TemplatePreviewProps> = ({ show, handleClose, data }) => {
	const { translate } = useTranslate();
	const navigate = useNavigate();
	const [activeIndex, setActiveIndex] = useState(0);
	const [selectedId, setSelectedId] = useState<any>(null);
	const [loadingStates, setLoadingStates] = useState<boolean[]>([]);

	useEffect(() => {
		setLoadingStates(new Array(data.previewImages?.length).fill(true));
	}, [data.previewImages]);

	const { data: templateDetails = {}, isLoading } = useGetTemplateDetailsQuery(selectedId);

	const handleSelect = (idx: number) => {
		setActiveIndex(idx);
	};

	const handleClick = () => {
		setSelectedId(data?.id);
	};

	const handleImageLoaded = (index: number) => {
		setLoadingStates((prev) => prev.map((state, idx) => (idx === index ? false : state)));
	};

	const handleImageError = (index: number) => {
		setLoadingStates((prev) => prev.map((state, idx) => (idx === index ? false : state)));
	};

	useEffect(() => {
		if (!isLoading && templateDetails && Object.keys(templateDetails)?.length && data?.id) {
			navigate(`${data.id}`);
			handleClose();
		}
	}, [selectedId, isLoading]);

	useEffect(() => {
		setActiveIndex(0);
	}, [show]);

	return (
		<Modal
			onHide={handleClose}
			show={show && data.previewImages?.length > 0}
			className="template-preview"
		>
			{show && data.previewImages?.length > 0 && (
				<>
					<div className="template-preview-head position-relative text-center mx-1 mx-sm-4 mx-md-5">
						<h4 className="mb-0 fw-bold">{translate('Template.templatePreview')}</h4>
					</div>
					<div className="template-preview-slider position-relative">
						<Carousel onSelect={handleSelect} controls={data.previewImages?.length > 1}>
							{data.previewImages?.map((preview: any, idx: number) => (
								<Carousel.Item key={`preview-${idx}`}>
									<div className="slide-img">
										{loadingStates[idx] && <TemplatePreviewSkeleton />}
										<img
											src={`${S3_URL}${preview}`}
											alt="template"
											className={`w-100 ${loadingStates[idx] ? 'd-none' : ''}`}
											onLoad={() => handleImageLoaded(idx)}
											onError={() => handleImageError(idx)}
											loading="lazy"
										/>
									</div>
								</Carousel.Item>
							))}
						</Carousel>
						<h5 className="position-absolute bottom-0 start-50 translate-middle-x mb-0">
							{translate('Template.page')} {activeIndex + 1}/{data.previewImages?.length}
						</h5>
					</div>
					<Button
						className="template-preview-btn w-100 text-white border-0 mb-0 mb-sm-3 mt-4 mx-auto"
						onClick={handleClick}
					>
						{translate('Template.editResume')}
					</Button>
				</>
			)}
		</Modal>
	);
};

export default TemplatePreview;
